import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const ActivityContainer = styled.div `
  border-left: 2px solid ${color("fill")};
  padding: 0 0 ${units(3)} ${units(4)};
  position: relative;
`;
export const Activity = styled.li `
  margin-left: ${units(2)};

  &:last-child ${ActivityContainer} {
    border-color: transparent;
  }
`;
export const IconContainer = styled.div `
  height: ${units(4)};
  width: ${units(4)};
  position: absolute;
  top: -${units(1)};
  left: -17px;

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &:after {
      border-radius: 50%;
      border: ${units(0.5)} solid ${color("container")};
      content: "";
      height: calc(100% + 8px);
      left: -4px;
      pointer-events: none;
      position: absolute;
      top: -4px;
      width: calc(100% + 8px);
      z-index: -2;
    }
  }
`;
export const Title = styled.p `
  ${typeStyle("subHeaderS")};
`;
export const Meta = styled.small `
  ${typeStyle("captionM")};
  color: ${color("typeMeta")};
  margin-left: 0;
  margin-right: 0;
`;
export const Notes = styled.p `
  ${typeStyle("bodyS")};
  margin: ${units(1.5)} 0 0 0;
  white-space: pre-line;
`;
